import { useAuth } from 'layout/context/auth-context'
import { useEffect, useState } from 'react'
import { getBrazilDate } from 'shared/utils/get-brazil-date'
import { HourlyEventCount } from 'domain/hourly-event-count'
import anprEventApiService from '../../anpr-events/api/anpr-event.api'
import ahcrEventApiService from '../../ahcr-events/api/ahcr-event.api'
import { ANPREventQueryParams } from '../../anpr-events/types/anpr-event-query-param'

export interface UseHourlyEventCountsHookReturn {
  /** Contagem combinada (ANPR + AHCR) por hora do dia, índice = hora (0-23). */
  hourlyCounts: number[]
  loading: boolean
}

const mergeIntoHourBuckets = (counts: HourlyEventCount[][]): number[] => {
  const buckets = new Array<number>(24).fill(0)

  counts.flat().forEach(({ hour, count }) => {
    if (hour >= 0 && hour < 24) {
      buckets[hour] += count
    }
  })

  return buckets
}

export const useHourlyEventCounts = (): UseHourlyEventCountsHookReturn => {
  const { clientId } = useAuth()
  const [hourlyCounts, setHourlyCounts] = useState<number[]>(
    new Array(24).fill(0)
  )
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!clientId) {
      return
    }

    const params = {
      endDate: getBrazilDate('end'),
      startDate: getBrazilDate('start'),
      clientId,
    } as ANPREventQueryParams

    setLoading(true)

    Promise.all([
      anprEventApiService.getANPREventsHourlyCounts(params),
      ahcrEventApiService.getAHCREventsHourlyCounts(params),
    ])
      .then(([anprResponse, ahcrResponse]) => {
        setHourlyCounts(
          mergeIntoHourBuckets([
            anprResponse.responseObject,
            ahcrResponse.responseObject,
          ])
        )
      })
      .catch((err) => {
        console.error(
          '⚠️ Dashboard: Falha ao carregar distribuição horária:',
          err
        )
      })
      .finally(() => setLoading(false))
  }, [clientId])

  return { hourlyCounts, loading }
}
